export const RENDER_MODES = {
  BASIC: 'BASIC',
  PERMISSIONS: 'PERMISSIONS',
  APPROVALS: 'APPROVALS',
} as const;

export type RenderMode = typeof RENDER_MODES[keyof typeof RENDER_MODES];
